module.exports = __webpack_public_path__ + "fonts/Quicksand-700-latin15.7b81366.woff2";